import React, { useState, useEffect, useRef } from "react";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min";
import paginationFactory from "react-bootstrap-table2-paginator";
import { Stepper, Step } from "react-form-stepper";
import { useNavigate } from "react-router-dom";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { Card, Button, ButtonGroup, Dropdown } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
// import Divider from "@material-ui/core/Divider";
import "../../../../utils/Css/Marketing.css";
import "../../../../utils/Css/Campagne.css";
import campagneSMSService from "./../../../../services/MarketingService/CampagneSMSService"
import clientService from "./../../../../services/MarketingService/ClientService"

import { TextField } from "@material-ui/core";
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import { Swal } from 'sweetalert2';
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";

const stepTitle = ["Creation", "Destinataires", "Date de l'envoi"];
function AddCampagneS() {
  const [nouvelleCampagneSMS, setNouvelleCampagneSMS] = useState({});
  const [clientIds, setClientIds] = useState([]); // pour recuperer les clients selectionnee
  const [clients, setClients] = useState([]); // pour recuperer les clients
  //const [selectAll, setSelectAll] = useState(false);
  const [selectedClients, setSelectedClients] = useState({});
  const [nbLignes, setNbLignes] = useState(2);

  const [debutDate, setdebutDate] = useState(null);

  const [success, setSuccess] = useState(null);
  const [erreur, setErreur] = useState(null);
  const [selectedClientCount, setSelectedClientCount] = useState(0); // Nouvelle variable
  const [selectAll, setSelectAll] = useState(false);

  // methode pour sweetAlert : pour afficher le success de la modification de publication
  // const handleSuccess = () => {
  //   Swal.fire({
  //     icon: "success",
  //     html: `<strong>${success}</strong>`,
  //     toast: true,
  //     position: "top-end",
  //     showConfirmButton: false,
  //     timer: 3000,
  //   });
  // };

  //useEffect
  useEffect(() => {
    if (success) {
      // handleSuccess();
    }
    AfficherListClients();
  }, []);

  const AfficherListClients = () => {
    try {
      clientService.AfficherListClients(getCurrentUserId()).then((response) => {
        setClients(response.data.success);

      })
    } catch (error) {
      console.log(error);
      setErreur(error.message);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setNouvelleCampagneSMS({ ...nouvelleCampagneSMS, [name]: value });
  };

  // filter date debut
  const onChangeStartDate = (event) => {
    setNouvelleCampagneSMS({
      ...nouvelleCampagneSMS,
      debutDate: event.target.value,
    });
  };

  //methode select checkbox table

  //methode select All client

  //methode d'ajout
  const ajouterCampagneSMS = async (event) => {
    event.preventDefault();

    const datacampagneSMS = {
      ...nouvelleCampagneSMS,
      budget: clientIds.length * 50,
    };
    // Appeler la méthode "ajouterCampagneSMS()" de "campagneSMSService" en passant les données comme arguments
    try {
      campagneSMSService.ajouterCampagneSMS(
        datacampagneSMS,
        clientIds,
        attachment
      ).then((response) => {
        console.log(response.data.success); // Afficher la réponse
        // Réinitialiser les champs
        toastr.success("Ajout validée avec success !! ")

        // setSuccess("Ajout validée avec success !! ");
        setTimeout(() => {
          navigate(`/Campagne/PageCampagneS`);
        }, 2000);
        // window.location.reload();
      }).catch((error) => {
        toastr.error("Erreur lors de l'insertion." + error)

      })

    } catch (error) {
      console.log(error); // Afficher l'erreur
    }
  };

  //Date debut
  const handleDateTimeChange = (moment) => {
    setNouvelleCampagneSMS({
      ...nouvelleCampagneSMS,
      debutDate: moment.toISOString(),
    });
  };

  //pagination
  const options = {
    sizePerPage: 7,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    paginationPosition: "bottom",
  };

  // route
  const navigate = useNavigate();

  //Stepper
  const [activeStep, setActiveStep] = useState(0);

  const handleNextStep = () => {
    setActiveStep(Math.min(activeStep + 1, 2));
  };
  const handleNextStepToFinal = () => {
    setActiveStep(Math.min(activeStep + 2, 2));
  };

  const handleBackStep = () => {
    setActiveStep(Math.max(activeStep - 1, 0));
  };
  const handleBackStepToStart = () => {
    setActiveStep(Math.max(activeStep - 2, 0));
  };

  const stepStyleConfig = {
    activeBgColor: "#848687",
    completedBgColor: "#333",
  };

  //condition sur radio button pour importer fichier de numero de clients
  const [isImporting, setIsImporting] = useState(false);
  const [attachment, setAttachment] = useState(null);

  const handleRadioChange = (event) => {
    if (event.target.value === "importer") {
      setIsImporting(true);


    } else {
      setIsImporting(false);
    }
  };
  const [fileName, setFileName] = useState("");

  const handleAttachmentChange = (event) => {
    setAttachment(event.target.files[0]);
    setFileName(event.target.files[0].name);
    setNbLignes(null);
  };

  const handleCompterLignes = () => {
    if (attachment) {
      const reader = new FileReader();
      reader.onload = () => {
        const lines = reader.result.split("\n");
        setNbLignes(lines.length);
      };
      reader.readAsText(attachment);
    }
  };

  useEffect(() => {
    handleCompterLignes();
  }, [attachment]);

  // Method to handle select all checkbox change
  const handleSelectAllCheckboxChange = (isSelect) => {
    const newSelectedClients = {};
    const newClientIds = [];

    clients.forEach((client) => {
      newSelectedClients[client.id] = isSelect;
      if (isSelect) {
        newClientIds.push(client.id);
      }
    });

    let updatedSelectAll = false;
    if (isSelect && newClientIds.length === clients.length) {
      updatedSelectAll = true;
    }

    setSelectedClients(newSelectedClients);
    setClientIds(newClientIds);
    setSelectAll(updatedSelectAll);
  };

  const handleCheckboxChange = (row, isSelect) => {
    const clientId = row.id;
    const newSelectedClients = { ...selectedClients };
    newSelectedClients[clientId] = isSelect;

    let newClientIds;
    if (isSelect) {
      // If the checkbox was checked, add the current client ID to the selected client IDs
      newClientIds = [...clientIds, clientId];
    } else {
      // If the checkbox was unchecked, remove the current client ID from the selected client IDs
      newClientIds = clientIds.filter((id) => id !== clientId);
    }

    setSelectedClients(newSelectedClients);
    setClientIds(newClientIds);
  };
  const columns = [
    { dataField: "lastName", text: "Nom" },
    { dataField: "firstName", text: "Prénom" },
    { dataField: "phoneNumber", text: "Numero" },
    { dataField: "age", text: "Age" },
    { dataField: "rue", text: "Rue" },
    { dataField: "ville", text: "Ville" },
    { dataField: "pays", text: "Pays" },
  ];

  return (

    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Campagne SMS </h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <a href="#">Marketing</a>
                </li>
                <li className="breadcrumb-item">
                  <a href="/Campagne">Campagne</a>
                </li>
                <li className="breadcrumb-item">
                  <a href="/Campagne/PageCampagneS">SMS</a>
                </li>
                <li className="breadcrumb-item active">Creation</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      {/* /.content-header */}

      {/* <Divider /> */}

      {/* content */}
      <section className="content mt-3">
        {/* container-fluid */}
        <div className="container-fluid">
          <div className="card card-dark">
            <div className="card-header">
              <h3 className="card-title">Ajouter Campagne SMS </h3>
            </div>
            <form >

              <div className="card-body">
                <Stepper styleConfig={stepStyleConfig} activeStep={activeStep}>
                  {stepTitle.map((title) => (
                    <Step key={title} label={title} />
                  ))}
                </Stepper>
                {activeStep === 0 ? (
                  <div className="row">
                    <div className="col">
                      <div className="form-group">
                        <label>Labelle</label>
                        <input
                          type="text"
                          className="form-control"
                          id="exampleInputEmail1"
                          placeholder="Labelle"
                          name="nom"
                          onChange={handleChange}
                          value={nouvelleCampagneSMS.nom || ""}
                        />
                      </div>
                      <div className="form-group">
                        <label> Contenu</label>
                        <textarea
                          className="form-control"
                          rows="3"
                          placeholder="Contenu SMS ..."
                          name="contenu"
                          onChange={handleChange}
                          value={nouvelleCampagneSMS.contenu || ""}
                        />
                      </div>
                      <div className="form-group">
                        <label> Contact</label>
                        <textarea
                          className="form-control"
                          rows="3"
                          placeholder="Contact SMS ..."
                          name="donneesContact"
                          onChange={handleChange}
                          value={nouvelleCampagneSMS.donneesContact || ""}
                        />
                      </div>

                      <div className="form-group">
                        <label> Destinataires</label>
                        <div className="custom-control custom-radio">
                          <input
                            className="custom-control-input custom-control-input-dark"
                            type="radio"
                            id="customRadio1"
                            name="customRadio"
                            value="liste"
                            checked={!isImporting}
                            onChange={handleRadioChange}
                          />
                          <label
                            htmlFor="customRadio1"
                            className="custom-control-label"
                          >
                            Liste
                          </label>
                        </div>
                        <div className="custom-control custom-radio">
                          <input
                            className="custom-control-input custom-control-input-dark"
                            type="radio"
                            id="customRadio2"
                            name="customRadio"
                            value="importer"
                            checked={isImporting}
                            onChange={handleRadioChange}
                          />
                          <label
                            htmlFor="customRadio2"
                            className="custom-control-label"
                          >
                            Importer fichier
                          </label>
                        </div>
                      </div>
                      <div className="form-group">
                        {isImporting && (
                          <div className="input-group">
                            <div className="custom-file">
                              <input
                                type="file"
                                className="custom-file-input"
                                id="exampleInputFile"
                                onChange={handleAttachmentChange}
                              />
                              <label
                                className="custom-file-label"
                                htmlFor="exampleInputFile"
                              >
                                {fileName || "Importer fichier CSV"}
                              </label>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ) : null}
                {activeStep === 1 ? (
                  <>
                    <Card className="Campagne-card-buttons">
                      <Card.Body>
                        <div className="row">
                          <div className="col">
                            <Card
                              style={{
                                backgroundColor: "#848687",
                                color: "white",
                              }}
                            >
                              <Card.Body>
                                <div className="row">
                                  <div className="col-3 text-center">
                                    <label className="col">
                                      Nombre de Destinataires
                                    </label>
                                    <label className="col">
                                      {clientIds.length}
                                    </label>
                                  </div>
                                  <div className="col-8">
                                    <label className="col">Filtres</label>
                                  </div>
                                </div>
                              </Card.Body>
                            </Card>
                          </div>
                          <div className="w-100"></div>
                          <div className="col">
                            <div className="table-container thead-dark mb-3">
                              <BootstrapTable
                                keyField="id"
                                data={clients}
                                columns={columns}
                                selectRow={{
                                  mode: "checkbox",
                                  clickToSelect: true,
                                  selected: clientIds,
                                  onSelect: handleCheckboxChange,
                                  onSelectAll: handleSelectAllCheckboxChange,
                                }}
                                bordered={false}
                                hover
                                condensed
                                pagination={paginationFactory(options)}
                                defaultSorted={[
                                  {
                                    dataField: "createdDate",
                                    order: "asc",
                                  },
                                ]}
                                faultSortDirection="asc"
                                noDataIndication={() => "No data found"}
                                headerClasses="thead-dark"
                              />
                            </div>
                            <div></div>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                    {/* /.table */}
                  </>
                ) : null}
                {activeStep === 2 ? (
                  <>
                    <Card className="Campagne-card-buttons">
                      <Card.Body>
                        <div className="row">
                          <div className="col">
                            <Card
                              style={{
                                backgroundColor: "#848687",
                              }}
                            >
                              <Card.Body>
                                <div className="row">
                                  <div className="col-3 text-center">
                                    <label className="col">Type</label>
                                    <label className="col">Email</label>
                                  </div>
                                  <div className="col-3 text-center">
                                    <label className="col">
                                      Destinataires
                                    </label>
                                    <label className="col">
                                      {isImporting
                                        ? nbLignes - 2
                                        : clientIds.length}
                                    </label>
                                  </div>

                                  <div className="col-3 text-center">
                                    <label htmlFor="startDate">
                                      Date de l'envoi{" "}
                                    </label>
                                    <div className="col-3 text-center">
                                      <label className="col">
                                        <TextField
                                          variant="outlined"
                                          value={
                                            nouvelleCampagneSMS.debutDate
                                          }
                                          onChange={onChangeStartDate}
                                          name="debutDate"
                                          id="datetime-local"
                                          type="datetime-local"
                                          defaultValue="date"
                                          InputLabelProps={{
                                            shrink: true,
                                          }}
                                          size="small"
                                        // className="mt-2"
                                        //style={{ backgroundColor: "white"}}
                                        />
                                      </label>
                                    </div>
                                  </div>

                                  <div className="col-3 text-center">
                                    <label className="col">Cout</label>
                                    <label className="col">
                                      {clientIds.length * 50}
                                    </label>
                                  </div>
                                </div>
                              </Card.Body>
                            </Card>
                          </div>
                          <div className="w-100"></div>

                          <div className="col">
                            <Card>
                              <Card.Body>
                                <div className="row">
                                  <h5 className="col-12 text-center font-weight">
                                    Aperçu de l'SMS envoyé aux
                                    <span> {clientIds.length} </span>
                                    destinataires
                                  </h5>
                                  <div className="col-12 text-center text-muted">
                                    <small>
                                      Cet aperçu est affiché à titre
                                      indicatif, le résultat final peut être
                                      différent
                                    </small>
                                  </div>

                                  <div className="container mt-3">
                                    <div className="row">
                                      <div className="col-sm"></div>
                                      <div className="col-sm">
                                        <div className="row">
                                          <div className="col">
                                            <label>Contenu :</label>
                                          </div>
                                          <div className="w-100"></div>

                                          <div className="col">
                                            <div>
                                              {nouvelleCampagneSMS.contenu}
                                            </div>
                                          </div>
                                        </div>
                                        <div className="row  mt-3">
                                          <div className="col">
                                            <label>Contact :</label>
                                          </div>
                                          <div className="w-100"></div>

                                          <div className="col">
                                            {
                                              nouvelleCampagneSMS.donneesContact
                                            }
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-sm"></div>
                                    </div>
                                  </div>
                                </div>
                              </Card.Body>
                            </Card>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                    {/* /.table */}
                  </>
                ) : null}
              </div>

              <div className="card-footer">
                <div className="row">
                  <div className="col">
                    {/* condition sur lsuivant et precedent */}
                    <FaChevronLeft
                      onClick={
                        isImporting ? handleBackStepToStart : handleBackStep
                      }
                    />
                    <FaChevronRight
                      onClick={
                        isImporting ? handleNextStepToFinal : handleNextStep
                      }
                    />
                  </div>

                  {/* condition sur les button Ajouter + annuler */}
                  <div className="col text-right" style={{ width: "100%" }}>
                    <Button
                      className="btn btn-secondary mr-2"
                      onClick={() => navigate("/Campagne/PageCampagneS")}
                      style={{ width: "150px" }}
                    >
                      Annuler
                    </Button>
                    <Button
                      className="btn btn-dark"
                      disabled={activeStep !== 2}
                      style={{ width: "150px" }}
                      onClick={ajouterCampagneSMS}
                    >
                      Ajouter
                    </Button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        {/* /.container-fluid */}
      </section>
    </div>

  );
}

export default AddCampagneS;
